import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const OrganizationReporting = () => {
  const [reportType, setReportType] = useState('executive');
  const [selectedMetrics, setSelectedMetrics] = useState({
    wellness: true,
    engagement: true,
    risk: true,
    improvement: false,
    demographics: false
  });

  const reportTypeOptions = [
    { value: 'executive', label: 'Executive Summary' },
    { value: 'detailed', label: 'Detailed Analytics' },
    { value: 'department', label: 'Department Breakdown' },
    { value: 'trend', label: 'Trend Analysis' },
    { value: 'benchmark', label: 'Industry Benchmark' }
  ];

  const scheduleOptions = [
    { value: 'once', label: 'Generate Once' },
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' }
  ];

  const handleMetricToggle = (metric) => {
    setSelectedMetrics(prev => ({
      ...prev,
      [metric]: !prev?.[metric]
    }));
  };

  const handleGenerateReport = () => {
    console.log('Generating report:', { reportType, selectedMetrics });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 shadow-elevation-2 border border-border">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-1 md:mb-2">
            Organization-Level Reporting
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Executive summaries with anonymized insights and benchmarking
          </p>
        </div>
        <div className="p-2 md:p-3 rounded-lg bg-primary/10">
          <Icon name="FileText" size={20} className="text-primary" />
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Report Type"
            options={reportTypeOptions}
            value={reportType}
            onChange={setReportType}
          />
          <Select
            label="Delivery Schedule"
            options={scheduleOptions}
            placeholder="Select schedule"
          />
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground mb-3">Include Metrics</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Checkbox
              label="Financial Wellness Scores"
              checked={selectedMetrics?.wellness}
              onChange={() => handleMetricToggle('wellness')}
            />
            <Checkbox
              label="Engagement Analytics"
              checked={selectedMetrics?.engagement}
              onChange={() => handleMetricToggle('engagement')}
            />
            <Checkbox
              label="Risk Assessment"
              checked={selectedMetrics?.risk}
              onChange={() => handleMetricToggle('risk')}
            />
            <Checkbox
              label="Improvement Trends"
              checked={selectedMetrics?.improvement}
              onChange={() => handleMetricToggle('improvement')}
            />
            <Checkbox
              label="Demographics Breakdown"
              checked={selectedMetrics?.demographics}
              onChange={() => handleMetricToggle('demographics')}
            />
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4 md:p-6">
          <h4 className="text-sm font-semibold text-foreground mb-3">Recent Reports</h4>
          <div className="space-y-3">
            {[
              { name: 'Q4 2025 Executive Summary', date: '2026-01-15', size: '2.4 MB' },
              { name: 'December Wellness Report', date: '2026-01-01', size: '1.8 MB' },
              { name: 'Annual Financial Health Analysis', date: '2025-12-31', size: '5.2 MB' }
            ]?.map((report, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-card rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-primary/10">
                    <Icon name="FileText" size={16} className="text-primary" />
                  </div>
                  <div>
                    <p className="text-xs md:text-sm font-medium text-foreground">{report?.name}</p>
                    <p className="text-xs text-muted-foreground">{report?.date} • {report?.size}</p>
                  </div>
                </div>
                <Button variant="ghost" size="sm" iconName="Download">
                  Download
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-3">
          <Button 
            variant="outline" 
            iconName="Eye" 
            iconPosition="left"
            fullWidth
          >
            Preview Report
          </Button>
          <Button 
            variant="default" 
            iconName="FileText" 
            iconPosition="left"
            onClick={handleGenerateReport}
            fullWidth
          >
            Generate Report
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrganizationReporting;